import { LoginWelcome } from '@/components/LoginPage/LoginWelcome'
import { useAuthStore } from '@/store'
import { AuthLoginState } from '@/store/auth/AuthenticationStore'
import { Rise } from '@/ui/core/motion'
import { SubmittedLoginForm } from './SubmittedLoginForm'
import { UnsubmittedLoginForm } from './UnsubmittedLoginForm'

export enum LOGIN_STATE {
	UNSUBMITTED = 0,
	SUBMITTED = 1,
}

/**
 * The three steps of the door: the welcome, the login form, then the code. The first two are
 * the screen's own state; the third is the auth store's, which flips once a code is sent. Each
 * step arrives the way every screen's content does.
 */
const LoginForm = ({ started, onStart }: { started: boolean; onStart: () => void }) => {
	const { loginState } = useAuthStore()
	const codeSent = loginState === AuthLoginState.CODE_SENT
	const step = codeSent ? 'code' : started ? 'email' : 'welcome'

	return (
		<Rise key={step} index={1}>
			{step === 'code' ? (
				<SubmittedLoginForm />
			) : step === 'email' ? (
				<UnsubmittedLoginForm />
			) : (
				<LoginWelcome onLogIn={onStart} />
			)}
		</Rise>
	)
}

export { LoginForm }
